import { createSelector } from 'reselect';
import { QR_DESIGN_DETAILS } from "forms/list";
import { getFormValues } from "redux-form";
import { COLOR_TYPES } from "routes/qrcodes/qr_design/DotSettingsSection";

const parseDotsOptionsIntoQrConfigurationDotSettings = (dotSettingsDetails) => {
	if (dotSettingsDetails.dotsColorType === COLOR_TYPES.SOLID) {
		return {
			type: dotSettingsDetails.details.dotsOptions.type,
			color: dotSettingsDetails.solid.color,
			gradient: undefined,
		};
	} else if (dotSettingsDetails.dotsColorType === COLOR_TYPES.GRADIENT) {
		return {
			type: dotSettingsDetails.details.dotsOptions.type,
			color: dotSettingsDetails.gradient.colorStops[0].color,
			gradient: {
				...dotSettingsDetails.gradient,
			},
		};
	}
};

const getQrCodeDesignDetails = getFormValues(QR_DESIGN_DETAILS);

export const getQrCodeDesignConfiguration = (qrDesignFormData) => {
	if (!qrDesignFormData) {
		return {
			name: undefined,
			details: {},
		};
	}
	let baseDotsColor;
	if (qrDesignFormData.dotsColorType === COLOR_TYPES.SOLID) {
		baseDotsColor = qrDesignFormData.solid.color;
	} else {
		baseDotsColor = qrDesignFormData.gradient.colorStops[0].color;
	}
	return {
		name: qrDesignFormData.name,
		details: {
			...qrDesignFormData.details,
			image: qrDesignFormData.logo.base64 ?? "",
			imageName: qrDesignFormData.logo.filename ?? "",
			cornersSquareOptions: {
				...qrDesignFormData.details.cornersSquareOptions,
				color: baseDotsColor,
			},
			cornersDotOptions: {
				...qrDesignFormData.details.cornersDotOptions,
				color: baseDotsColor,
			},
			dotsOptions: parseDotsOptionsIntoQrConfigurationDotSettings(qrDesignFormData),
		},
	};
};

export const qrCodeDesignConfiguration = createSelector([getQrCodeDesignDetails], getQrCodeDesignConfiguration);
